import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class FeeSerializer extends BaseSerializer {
  deserialize(raw) {
    const serverRes = raw.data || raw.error;
    const success =
      serverRes.statusCode == 200 ||
      serverRes.statusCode == 201 ||
      serverRes.statusCode == 404;
    if (!success) {
      return {
        statusCode: serverRes.statusCode || raw.status || 500,
        success: false,
        message:
          (serverRes.message || 'Erreur lors de la récupération') +
          ` Code d'erreur: FEE_ERR_${
            serverRes.statusCode || raw.status || '1000'
          }`,
        data: null
      };
    }
    return {
      statusCode: 200,
      success: true,
      message: 'Fees got',
      data: (Array.isArray(serverRes?.data) ? serverRes?.data : []).map(
        (fee) => {
          return {
            country: fee.country,
            operation: fee.operation,
            processor: fee.processor || 'any',
            serviceFee: fee.serviceFee || 0,
            profitFee: fee.profitFee || 0,
            processorFee: fee.processorFee || 0,
            discountFee: fee.discountFee || 0,
            bonusFee: fee.bonusFee || 0,
            affiliationBonus: fee.affiliationBonus || 0,
            merchantSupportFee: fee.merchantSupportFee || false,
            service: fee.service || '{lacasaeBettingServiceName}',
            userId: fee.userId || '{lacasaeBettingServiceName}',
            createdAt: fee.createdAt,
            updatedAt: fee.updatedAt
          };
        }
      )
    };
  }

  serialize(fee) {
    return {
      userId: fee.userId || '{lacasaeBettingServiceName}',
      country: fee.country,
      service: fee.service || '{lacasaeBettingServiceName}',
      operation: fee.operation,
      processor: fee.processor || 'any',
      profitFee: Number(fee.profitFee) || 0,
      serviceFee: Number(fee.serviceFee) || 0,
      processorFee: Number(fee.processorFee) || 0,
      discountFee: Number(fee.discountFee) || 0,
      bonusFee: Number(fee.bonusFee) || 0,
      affiliationBonus: Number(fee.affiliationBonus) || 0,
      merchantSupportFee: Boolean(fee.merchantSupportFee)
    };
  }
}

export const serializer = new FeeSerializer();
